module.exports = __webpack_public_path__ + "static/media/darkforces2.11496c73.gif";